
export default {
  name: "hyperItem",
  props: ["item", "product", "element", "carousel", "inGrid", "index"],
  data() {
    return {
      bundle: this.element !== undefined ? this.element.bundle : false,
      productLocal: this.$hyperProduct.interceptor(
        this.item,
        this.element,
        this.product
      ),
      styles: {},
      stylesHover: {},
      stylesMobile: {},
      stylesMobileHover: {},
    };
  },
  created() {
    if (process.browser) {
      let cssLink = document.querySelector(`#product${this.productLocal.uid}`);
      if (!cssLink) {
        let link = document.createElement("link");
        link.href = `/ecss/product/${this.$store.getters.store._id}/${
          this.productLocal.uid
        }.css?build_no=${(this.$store.getters.store.build || {}).build_no}&v=${
          ((this.$store.getters.store || {}).build_no || {}).timestamp
        }`;
        link.id = `product${this.productLocal.uid}`;
        link.rel = "stylesheet";
        link.type = "text/css";
        document.querySelector("head").appendChild(link);
      }
    }
    if (this.carousel && this.$store.getters.isMobile) {
      this.productLocal.styleImportant = {
        width: "100%",
      };
    }
  },
  mounted(){
    if(process.browser){
     if(this.productLocal?.impression){
      try{
        eval(this.productLocal.impression);
      }catch(e){
      }
     }
    }
  },
  methods: {
    
  },
};
